var map = {
	"./decidim/avatar-multiuser.png": 1838,
	"./decidim/brands/google.svg": 737,
	"./decidim/cc-badge.png": 1328,
	"./decidim/decidim-logo.svg": 5836,
	"./decidim/default-avatar.svg": 2596,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 3728,
	"./decidim/icons.svg": 3967,
	"./decidim/pattern.png": 6016,
	"./decidim/placeholder-card-g.svg": 8709,
	"./decidim/placeholder-card-l.svg": 4350,
	"./decidim/placeholder.jpg": 4413,
	"./decidim/remixicon.symbol.svg": 8817,
	"./decidim/vendor/leaflet/layers-2x.png": 144,
	"./decidim/vendor/leaflet/layers.png": 1343,
	"./decidim/vendor/leaflet/marker-icon-2x.png": 8474,
	"./decidim/vendor/leaflet/marker-icon.png": 4209,
	"./decidim/vendor/leaflet/marker-shadow.png": 1006,
	"./decidim/vendor/social-share-button/douban.svg": 9664,
	"./decidim/vendor/social-share-button/email.svg": 1629,
	"./decidim/vendor/social-share-button/facebook.svg": 8275,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 4077,
	"./decidim/vendor/social-share-button/hacker_news.svg": 6189,
	"./decidim/vendor/social-share-button/linkedin.svg": 9045,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 5366,
	"./decidim/vendor/social-share-button/pinterest.svg": 3299,
	"./decidim/vendor/social-share-button/reddit.svg": 5751,
	"./decidim/vendor/social-share-button/telegram.svg": 6858,
	"./decidim/vendor/social-share-button/tumblr.svg": 953,
	"./decidim/vendor/social-share-button/twitter.svg": 3100,
	"./decidim/vendor/social-share-button/vkontakte.svg": 1074,
	"./decidim/vendor/social-share-button/wechat.svg": 7373,
	"./decidim/vendor/social-share-button/whatsapp.svg": 9149,
	"./decidim/vendor/social-share-button/x.svg": 8061,
	"./decidim/vendor/social-share-button/xing.svg": 5811
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7605;